var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.288,
    height: 13.759,
    viewBox: "0 0 15.288 13.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-filter",
    "data-name": "Icon feather-filter",
    d: "M18.288,4.5H3l6.115,7.231v5l3.058,1.529V11.731Z",
    transform: "translate(-3 -4.5)",
    fill: "#2699fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconBlue);
export default __webpack_public_path__ + "static/media/filter-icon-blue.cf19a0d2a5a09a09f9070e73790408bf.svg";
export { ForwardRef as ReactComponent };